import { BreadCrumbs } from '@app/components/BreadCrumbs';
import { Layout } from '@app/components/Layout';
import { Stack } from '@mui/material';

import { FeedbackList } from './FeedbackList';

export function Feedbacks() {
  return (
    <Layout>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <BreadCrumbs
          links={[
            {
              label: 'Dashboard',
              link: '/',
            },
            {
              label: 'Student Opportunities',
              link: '/',
            },
            {
              label: 'Feedbacks',
              link: '/student-opportunities/feedbacks',
            },
          ]}
        />
      </Stack>
      <FeedbackList />
    </Layout>
  );
}
